import { inject, Injectable, Type } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private modalService = inject(NgbModal);
  constructor() { }
  private modalRefs: NgbModalRef[] = [];

  openComponentModal<T>(component: Type<T>, options: any = {}): NgbModalRef {
    options.centered = options.centered ?? true;
    const modalRef = this.modalService.open(component, options);
    if (options.data) {
      modalRef.componentInstance.data = options.data;
    }

    this.trackModal(modalRef);
    return modalRef;
  }

  closeAll(): void {
    this.modalRefs.forEach((ref) => {
      try {
        ref.dismiss();
      } catch { }
    });
    this.modalRefs = [];
  }

  private trackModal(modalRef: NgbModalRef): void {
    this.modalRefs.push(modalRef);
    modalRef.result.finally(() => {
      this.untrackModal(modalRef);
    });
  }
  private untrackModal(modalRef: NgbModalRef): void {
    const index = this.modalRefs.indexOf(modalRef);
    if (index !== -1) {
      this.modalRefs.splice(index, 1);
    }
  }
}
